import React, { useState, createContext, useContext } from "react";
import { getSingleUser } from "../modules/OrganizationQuickTales/hooks/QuickTalesHooks";
import {
  Timestamp,
  addDoc,
  doc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { NotificationRef, db, sendPushNotification } from "../firebase";
import { useAuth } from "../hooks";

export const CommonContext = createContext();
export const useCommonContext = () => useContext(CommonContext);

export const CommonProvider = ({ children }) => {
  const { currentUser } = useAuth();
  // states
  const [dateOptionReset, setDateOptionReset] = useState(true);

  const handleOnSendNotification = async ({ userId, userData, data }) => {
    const userSettings = userData?.settings ?? {};
    if (userSettings?.notifications) {
      await sendPushNotificationToUser({ userId, data });
      console.log(`send push notification for ${data?.type} to user`);
    }
    await insertNotificationInDB(data);
  };

  const sendPushNotificationToUser = async ({ data, userId }) => {
    const userTemp = await getSingleUser(userId);
    let tokens = userTemp.data().fcmTokens;
    if (tokens && tokens.length > 0) {
      // const { CLOUD_FUNCTION_BASE_URL } = configs;
      const function_URL =
        process.env.REACT_APP_PROJECT_ENVIROMENT == "staging"
          ? "https://us-central1-quicktales-staging.cloudfunctions.net"
          : process.env.REACT_APP_PROJECT_ENVIROMENT == "production"
          ? "https://us-central1-quicktales-prod.cloudfunctions.net"
          : "https://us-central1-quicktales-f8a59.cloudfunctions.net";
      return fetch(`${function_URL}/sendPushNotification`, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          title: data?.title,
          body: data?.subTitle,
          tokens: tokens,
          data,
        }),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          console.log(
            "NOTIFICATION RESPONSE==>",
            JSON.stringify(responseJson, null, 3)
          );
          return true;
        })
        .catch((error) => {
          console.log("error in sendPushNotificationToUser", error);
          return false;
        });
    }
  };

  // const sendPushNotificationToUser = async ({ data, userId }) => {
  //   const userTemp = await getSingleUser(userId);
  //   let tokens = userTemp.data().fcmTokens;
  //   console.log("==tokens==", tokens);
  //   await sendPushNotification({
  //     title: data?.title,
  //     body: data?.subTitle,
  //     tokens: tokens,
  //   });
  //   // await sendPushNotification({ data, userId });
  //   // if (tokens && tokens.length > 0) {
  //   //   // const { notifications } = configs;
  //   //   return fetch("https://fcm.googleapis.com/fcm/send", {
  //   //     method: "POST",
  //   //     headers: new Headers({
  //   //       "Content-Type": "application/json",
  //   //       Authorization: `key=AAAAycZk-c0:APA91bEhbrtFdfz9HiYPUOo7Pi96HZ0HUbft7NZeYhDuiv5Ck0rW_BE-jK4aIDz6N0i8LjnX5-EYI4iSs5MS7ADpx-zRpwrpwF3oC-fccViOBNW8wSsz78DecyI2Gj0u_-UTl9DzTS7F`,
  //   //     }),
  //   //     body: JSON.stringify({
  //   //       registration_ids: tokens,
  //   //       notification: {
  //   //         title: data?.title,
  //   //         body: data?.subTitle,
  //   //         mutable_content: true,
  //   //         content_available: true,
  //   //         sound: "Tri-tone",
  //   //       },
  //   //       data,
  //   //     }),
  //   //   })
  //   //     .then((response) => response.json())
  //   //     .then((responseJson) => {
  //   //       console.log(
  //   //         "NOTIFICATION RESPONSE==>",
  //   //         JSON.stringify(responseJson, null, 3)
  //   //       );
  //   //       return true;
  //   //     })
  //   //     .catch((error) => {
  //   //       console.log("error in sendNotificationToUser", error);
  //   //       return false;
  //   //     });
  //   // }
  // };

  const insertNotificationInDB = async (data) => {
    const { fromUserId, toUserId } = data;
    try {
      const queryRef = query(
        NotificationRef,
        where("fromUserId", "==", fromUserId),
        where("toUserId", "==", toUserId),
        where("subType", "==", "connect_request_received"),
        where("active", "==", true)
      );
      const querySnapshot = await getDocs(queryRef);
      if (!querySnapshot.empty) {
        // If there is already an existing notification, do not insert a new one
        console.log("Notification already exists, not inserting a new one.");
        return false; // Returning false or any other indicator that no new document was added
      }
      // data.createdAt = firestore.FieldValue.serverTimestamp();
      // data.createdAt = Timestamp.now();
      data.createdAt = Timestamp.now();
      data.active = data?.active ?? true;
      data.isRead = false;
      // return NOTIFICATIONS_COLLECTION.add(data)
      return await addDoc(NotificationRef, data)
        .then((doc) => {
          return doc.id;
        })
        .catch((e) => {
          console.log("error in insertNotificationInDB", e);
          return false;
        });
    } catch (error) {
      console.error("Error in insertNotificationInDB:", error);
      return false;
    }
  };

  // await handleOnSendNotification({
  //   userId: userDetails?.id,
  //   userData: userDetails,
  //   data: {
  //     fromUserId: currentUser?.id,
  //     // fromUserId: fromUser?.userId,
  //     toUserId: userDetails?.id,
  //     title: `You are added as a contributor`,
  //     // title: `You are added as a contributor to ${organization.title}`,
  //     subTitle: `You have been added as a contributor to ${organization.title}, you can now submit QTs to ${organization.title}`,
  //     type: "invites",
  //     subType: "contributor_request_accepted",
  //     docRef: "organizations",
  //     //organization id to which the user is added as contributor
  //     docRefId: organization?.id ?? '',
  //   },
  // });

  return (
    <CommonContext.Provider
      value={{
        setDateOptionReset,
        dateOptionReset,
        handleOnSendNotification,
      }}
    >
      {children}
    </CommonContext.Provider>
  );
};
